'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SiteStorage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _wixSdk = require('wix-sdk');

var _wixSdk2 = _interopRequireDefault(_wixSdk);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function delay(time) {
  return new Promise(function (resolve) {
    setTimeout(resolve, time);
  });
}

function getStyleParams() {
  return new Promise(function (resolve) {
    _wixSdk2.default.Styles.getStyleParams(resolve);
  });
}

function _getDataPublic(key) {
  var dataPublic = new Promise(function (resolve) {
    return _wixSdk2.default.Data.Public.get(key, { scope: _wixSdk2.default.Data.SCOPE.COMPONENT }, function (data) {
      resolve(data && data[key]);
    }, function () {
      resolve(undefined);
    });
  });
  return Promise.race([dataPublic, delay(1500)]);
}

var SiteStorage = exports.SiteStorage = function () {
  function SiteStorage(prefix, separator) {
    _classCallCheck(this, SiteStorage);

    this.prefix = prefix;
    this.separator = separator === undefined ? '::' : separator;
    this.cache = {};
    this.cacheBool = {};
    this.cacheNumbers = {};
  }

  _createClass(SiteStorage, [{
    key: '_joinWithSeparator',
    value: function _joinWithSeparator() {
      return Array.prototype.join.call(arguments, this.separator);
    }
  }, {
    key: '_getPrefixedKey',
    value: function _getPrefixedKey(key) {
      return this._joinWithSeparator(this.prefix, key);
    }
  }, {
    key: 'getBool',
    value: function getBool(key) {
      var prefix = this._getPrefixedKey(key);
      if (prefix in this.cacheBool) {
        // setEditorParam does not change params after they were retrieved
        return Promise.resolve(this.cacheBool[prefix]);
      }
      return getStyleParams().then(function (params) {
        return params.booleans[prefix];
      });
    }
  }, {
    key: 'setBool',
    value: function setBool(key, value) {
      var prefix = this._getPrefixedKey(key);
      this.cacheBool[prefix] = value;

      return getStyleParams().then(function () {
        return new Promise(function (resolve) {
          _wixSdk2.default.Styles.setBooleanParam(prefix, { value: value }, resolve);
        });
      });
    }
  }, {
    key: 'getNumber',
    value: function getNumber(key) {
      var prefix = this._getPrefixedKey(key);

      if (prefix in this.cacheNumbers) {
        // setEditorParam does not change params after they were retrieved
        return Promise.resolve(this.cacheNumbers[prefix]);
      }

      return getStyleParams().then(function (params) {
        return params.numbers[prefix];
      });
    }
  }, {
    key: 'setNumber',
    value: function setNumber(key, value) {
      var prefix = this._getPrefixedKey(key);
      this.cacheNumbers[prefix] = value;
      return getStyleParams().then(function () {
        return new Promise(function (resolve) {
          _wixSdk2.default.Styles.setNumberParam(prefix, { value: value }, resolve);
        });
      });
    }

    /* *
     * @name WMP.SiteStorage#get
     * @description Get value by key from wix site
     *
     * @param {string} key Name of the property
     * @returns {Promise} Value of the property (string|null)
     * @param {Object} [options] Options of settings.
     * @param {Boolean} [options.skipData=false] Whether to skip getting from Wix.Data.
     */

  }, {
    key: 'get',
    value: function get(key, options) {
      if (!options) {
        options = {};
      }
      var prefixedKey = this._getPrefixedKey(key);
      if (prefixedKey in this.cache) {
        // setEditorParam does not change params after they were retrieved
        return Promise.resolve(this.cache[prefixedKey]);
      }

      return Promise.all([getStyleParams(), options.skipData ? Promise.resolve() : this.getDataPublic(key)]).then(function (args) {
        var styleParams = args[0];
        var dataParam = args[1];
        return dataParam || styleParams.fonts[prefixedKey] && styleParams.fonts[prefixedKey].value;
      });
    }

    /* *
     * @name WMP.SiteStorage#remove
     * @description Removes value by key from wix site
     *
     * @param {string} key Name of the property
     * @returns {Promise}
     */

  }, {
    key: 'remove',
    value: function remove(key) {
      var prefixedKey = this._getPrefixedKey(key);
      var cache = this.cache;

      return getStyleParams().then(function () {
        var resetFontParams = new Promise(function (resolve, reject) {
          _wixSdk2.default.Styles.setFontParam(prefixedKey, {
            value: { value: undefined }
          }, resolve, reject);
        });
        var removeDataParam = new Promise(function (resolve) {
          _wixSdk2.default.Data.Public.remove(prefixedKey, { scope: _wixSdk2.default.Data.SCOPE.COMPONENT }, function () {
            delete cache[prefixedKey];
            resolve();
          });
        });
        var removeDataParamTimeout = Promise.race([removeDataParam, delay(3500)]);
        return Promise.all([resetFontParams, removeDataParamTimeout]);
      });
    }

    /* *
     * @ngdoc method
     * @name wix.siteStorage#set
     * @description Set property by key
     *
     * @param {string} key Name of the property
     * @param {string} value Value of the property.
     * @param {Object} [options] Options of settings.
     * @param {Boolean} [options.skipData = false] Whether to skip saving to Wix.Data.
     */

  }, {
    key: 'set',
    value: function set(key, value, options) {
      var _this = this;

      if (value === undefined) {
        return Promise.resolve();
      }
      if (!options) {
        options = {};
      }

      var prefixedKey = this._getPrefixedKey(key);
      this.cache[prefixedKey] = value;

      return getStyleParams().then(function () {
        var setFontParams = new Promise(function (resolve, reject) {
          _wixSdk2.default.Styles.setFontParam(prefixedKey, { value: { value: value } }, resolve, reject);
        });
        var setDataPublic = options.skipData ? Promise.resolve() : _this.setDataPublic(key, value);
        return Promise.all([setFontParams, Promise.race([setDataPublic, delay(1500)])]);
      });
    }
  }, {
    key: 'setDataPublic',
    value: function setDataPublic(key, value) {
      var prefixedKey = this._getPrefixedKey(key);
      return new Promise(function (resolve, reject) {
        _wixSdk2.default.Data.Public.set(prefixedKey, value, { scope: _wixSdk2.default.Data.SCOPE.COMPONENT }, function (data) {
          _wixSdk2.default.Settings.triggerSettingsUpdatedEvent('data:update', data);
          resolve(data);
        }, reject);
      });
    }
  }, {
    key: 'getDataPublic',
    value: function getDataPublic(key) {
      var prefixedKey = this._getPrefixedKey(key);
      return _getDataPublic(prefixedKey);
    }
  }]);

  return SiteStorage;
}();
//# sourceMappingURL=site-storage.js.map



//////////////////
// WEBPACK FOOTER
// ../~/music-shared/dist/src/site-storage/site-storage.js
// module id = 62
// module chunks = 9